import logo_white from '../../media/logo_white.svg';
import '../../css/bar.css';
import { useToast } from '../../providers/toastProvider';
import { useConfig } from '../../providers/configProvider';
import { logoutSystem } from '../../api/system-account-api';
import { useLanguage } from '../../providers/preferenceProvider';
import { useState, useEffect } from 'react';

const EmptyBar = ({ roomName }) => {
  const { showToast } = useToast();
  window.showGlobalToast = showToast;
  const { config } = useConfig();
  const isSystemAccount = config?.user?.systemAccount;
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();  
  const handleLogout = async () => {
    setLoading(true);
    try {
      await logoutSystem(password);
      showToast(t.display.logoutSuccess);
      setShowPasswordPopup(false);
      window.location.replace('/');
    } catch {
        
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  useEffect(() => {
    if (showPasswordPopup) {
      const timer = setTimeout(() => {
        setShowPasswordPopup(false);
      }, 60000);
  
      return () => clearTimeout(timer);
    }
  }, [showPasswordPopup]);

  return (
    <header className="header-empty">
      <div className="left-section">
        <div className="logo-section relative">
          {isSystemAccount ? (
            <button
              onClick={() => setShowPasswordPopup(!showPasswordPopup)}
              className="focus:outline-none"
              aria-label="Logout system account"
            >
              <img className="logo-empty" src={logo_white} alt="42Workspace" />
            </button>
          ) : (
            <img className="logo-empty" src={logo_white} alt="42Workspace" />
          )}
          <div className="vertical-stripe"></div>

          {showPasswordPopup && (
            <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-300 shadow-md z-50 p-4 rounded-md">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
                className="flex flex-col gap-3"
              >
                <label htmlFor="sys-pass" className="text-sm font-medium text-gray-700">
                  {t.display.enterPassword}
                </label>
                <input
                  id="sys-pass"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  className="overlay-admin-input"
                />
                <button
                  type="submit"
                  disabled={loading || !password.trim()}
                  className="btn w-full"
                >
                  {loading ? t.display.loggingOut : t.display.logout}
                </button>
              </form>
            </div>
          )}
        </div>
        {roomName &&<div className='absolute left-1/2 transform -translate-x-1/2 text-6xl text-white whitespace-nowrap'>
          {roomName}
        </div>
        }
      </div>
      
    </header>
  );
};

export default EmptyBar;
